import type { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import styles from './BreadcrumbItem.module.css';

export const BreadcrumbItem: FC<
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
> = ({ children, className, ...props }) => (
  <div className={cx(styles.item, className)} {...props}>
    {children}
  </div>
);
